import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import { useUserContext } from '@/contexts/UserContext.tsx'

export const NotFoundPage = () => {
  const { user } = useUserContext()
  const navigate = useNavigate()

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate(user ? '/projects' : '/')
    }, 5000)

    return () => clearTimeout(timer)
  }, [user, navigate])

  return (
    <div className="flex flex-col items-center justify-center h-screen gap-6 bg-surface-background">
      <span className="text-[70px]/[70px]">🫥</span>
      <h1 className="font-EN-KR-heading1-bold text-contents-primary">404 Not Found</h1>
      <p className="flex flex-col items-center font-EN-KR-heading1-regular text-contents-tertiary">
        <span>The page you are looking for does not exist.</span>
        <span>You will be redirected in 5 seconds.</span>
      </p>
    </div>
  )
}
